import { useRoasts } from "@/hooks/useStore";
import { RoastCard } from "@/components/RoastCard";
import { Button } from "@/components/ui/button";
import { Plus, Flame } from "lucide-react";
import { useApp } from "@/App";

export function Feed() {
	const { roasts, loading } = useRoasts();
	const { navigate } = useApp();

	if (loading) {
		return (
			<div className="flex flex-col items-center gap-4 py-20">
				<Flame className="h-8 w-8 animate-pulse text-orange-500" />
				<p className="text-muted-foreground">Loading roasts...</p>
			</div>
		);
	}

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<div>
					<h1 className="text-2xl font-bold tracking-tight">Latest Roasts</h1>
					<p className="text-sm text-muted-foreground">
						Brutal feedback on landing pages. No feelings spared.
					</p>
				</div>
				<Button onClick={() => navigate({ name: "submit" })} className="gap-1.5">
					<Plus className="h-4 w-4" />
					Submit Page
				</Button>
			</div>

			<div className="space-y-4">
				{roasts.map((roast) => (
					<RoastCard key={roast.id} roast={roast} />
				))}
			</div>

			{roasts.length === 0 && (
				<div className="rounded-lg border border-dashed border-border/60 py-16 text-center">
					<Flame className="mx-auto mb-3 h-10 w-10 text-muted-foreground/40" />
					<p className="text-muted-foreground">No roasts yet. Be the first to submit!</p>
				</div>
			)}
		</div>
	);
}
